import {
  account_info,
  bank_account,
  bars_enam,
  cpf_cnpj,
  credit_card,
  customer_id,
  email,
  evp,
  iban, link_out, loan,
  manualDetails,
  manualNames,
  pay_bills,
  phone_number,
  request_payment,
  send_money,
  split_payment,
  top_up,
} from '../utils/DictionaryManagementUtils';

export const servicesConfigurations = () => ({
  screens_ordering: [
    'send_money_0',
    'loan_0',
    'account_info_0',
    'pay_bills_0',
    'request_payment_0',
    'split_payment_0',
    'top_up_0',
    'link_out_0',
  ],
  menu: menuConfigurations(),
  send_money_0: sendMoneyConfigurations(),
  loan_0: loanConfigurations(),
  account_info_0: accountInfoConfigurations(),
  pay_bills_0: payBillsConfigurations(),
  request_payment_0: requestPaymentConfigurations(),
  split_payment_0: splitPaymentConfigurations(),
  top_up_0: topUpConfigurations(),
  link_out_0: linkOutConfigurations(),
});

export const menuConfigurations = () => ({
  bank_logo: {
    fName: null,
    fUri: null,
    fID: null,
  },
  iMsg_bank_logo: {
    fName: null,
    fUri: null,
    fID: null,
  },
  keyboard_logo: {
    fName: null,
    fUri: null,
    fID: null,
  },
  hotkey_qab: {
    fName: null,
    fUri: null,
    fID: null,
  },
  keyboard_disabled_logo: {
    fName: null,
    fUri: null,
    fID: null,
  },
  layout_menu_screen: false,
  welcome_title: true,
  show_account_balance: false,
  select_currency: false,
  icon_shape_bars_enam: bars_enam,
  current_account: 'Current account',

});

// Services
export const sendMoneyConfigurations = () => ({
  name: 'Send Money',
  sub_category: send_money,
  duplication_number: 0,
  selected: true,
  icon: {
    fName: null,
    fUri: null,
    fID: null,
  },
  icon_action_bar: {
    fName: null,
    fUri: null,
    fID: null,
  },
  auth_within: false,
  screens_ordering: [
    'recipient',
    'amount',
    'reference',
    'confirmation',
    'success',
  ],
  recipient: getRecipient(),
  amount: { ...getAmount() },
  reference: getReference(),
  confirmation: getConfirmation(),
  success: getSuccess(),
});

export const requestPaymentConfigurations = () => ({
  name: 'Request Payment',
  selected: true,
  sub_category: request_payment,
  duplication_number: 0,
  icon: {
    fName: null,
    fUri: null,
    fID: null,
  },
  icon_action_bar: {
    fName: null,
    fUri: null,
    fID: null,
  },
  auth_within: false,
  screens_ordering: [
    'reference',
    'amount',
    'recipient',
    'confirmation',
    'success',
  ],
  recipient: getRecipient(),
  amount: { ...getAmount() },
  reference: getReference(),
  confirmation: getConfirmation(),
  success: getSuccess(),
});

export const splitPaymentConfigurations = () => ({
  name: 'Split Payment',
  selected: true,
  sub_category: split_payment,
  duplication_number: 0,
  icon: {
    fName: null,
    fUri: null,
    fID: null,
  },
  icon_action_bar: {
    fName: null,
    fUri: null,
    fID: null,
  },
  auth_within: false,
  screens_ordering: [
    'reference',
    'amount',
    'recipient',
    'confirmation_split',
    'success',
  ],
  recipient: getRecipient(true),
  amount: { ...getAmount() },
  reference: getReference(),
  confirmation_split: getConfirmation(),
  success: getSuccess(),
});

export const topUpConfigurations = () => ({
  name: 'Top Up',
  selected: true,
  sub_category: top_up,
  duplication_number: 0,
  icon: {
    fName: null,
    fUri: null,
    fID: null,
  },
  icon_action_bar: {
    fName: null,
    fUri: null,
    fID: null,
  },
  auth_within: false,
  screens_ordering: [
    'recipient',
    'operator',
    'amount_package',
    'reference',
    'confirmation',
    'success',
  ],
  recipient: getRecipient(false, false, true, false, false, true, false, false, false),
  operator: getOperator(),
  amount_package: getAmountPackage(),
  reference: getReference(),
  confirmation: getConfirmation(),
  success: getSuccess(),
});

export const accountInfoConfigurations = () => ({
  name: 'Account Info',
  selected: true,
  sub_category: account_info,
  duplication_number: 0,
  icon: {
    fName: null,
    fUri: null,
    fID: null,
  },
  icon_action_bar: {
    fName: null,
    fUri: null,
    fID: null,
  },
  auth_within: false,
  screens_ordering: [
    'balance',
    'transactions',
  ],
  balance: {
    account_balance: 'Account balance',
  },
  transactions: {
    enable_more_details_per_transaction: false,
    show_link_transactions_list: true,
    no_transactions_result: 'No results',
    transaction_details: 'Transaction details',
    confirm_action: 'Confirm action',
    go_account_balance: 'Go back to your account balance',
  },

});

export const linkOutConfigurations = () => ({
  name: 'Link Out',
  sub_category: link_out,
  duplication_number: 0,
  selected: true,
  icon: {
    fName: null,
    fUri: null,
    fID: null,
  },
  icon_action_bar: {
    fName: null,
    fUri: null,
    fID: null,
  },
  auth_within: false,
  screens_ordering: [
    'link_out',
  ],
  link_out: {},
});

export const loanConfigurations = () => ({
  name: 'Loan',
  sub_category: loan,
  duplication_number: 0,
  selected: false,
  icon: {
    fName: null,
    fUri: null,
    fID: null,
  },
  icon_action_bar: {
    fName: null,
    fUri: null,
    fID: null,
  },
  auth_within: false,
  screens_ordering: [
    'amount',
    'number',
    'source',
    'option',
    'confirmation',
    'success',
  ],
  amount: {
    ...getAmount(),
    select_currency: false,
    show_account_balance: false,
  },
  source: getSource(),
  number: getNumber(),
  option: getOption(),
  confirmation: getConfirmation(),
  success: getSuccess(),
}
);
export const payBillsConfigurations = () => ({
  name: 'Pay Bills',
  selected: true,
  sub_category: pay_bills,
  duplication_number: 0,
  icon: {
    fName: null,
    fUri: null,
    fID: null,
  },
  icon_action_bar: {
    fName: null,
    fUri: null,
    fID: null,
  },
  auth_within: false,
  screens_ordering: [
    'select_bill',
    'confirmation_bill',
    'success',
  ],
  select_bill: getSelectBill(),
  confirmation_bill: getConfirmationBill(),
  success: getSuccess(),
});

// Steps
const getConfirmationBill = () => ({
  allow_customer_to_change_payment_date: true,
  does_it_look_ok: 'How does it look?',
  more_details: 'More details',
  confirm_payment: 'Pay bill',
  go_back_to_menu: 'Go back to the menu',
  payment_date: 'Payment date',
  today: 'Today',
  close: 'Close',
});

const getSelectBill = () => ({
  enable_customer_to_bill_code_manually: true,
  enable_customer_to_scan_barcode: false,
  show_account_balance: true,
  your_bills: 'Pay bills',
  pay_now: 'Pay now',
  insert_another_bill: 'Enter bill number',
  how_much_to_transfer: 'Enter amount to transfer',
  account_balance: 'Account balance',
  select_paying_account: 'Select paying account',
  title: 'Select paying account',
  add_new_bill: 'Add new bill',
  scan_barcode: 'Scan barcode',
  type_the_barcode: 'Type the barcode',
  type_the_barcode_title: 'Type the barcode',
  scan_bill_barcode: 'Scan bill barcode',
  invalid_qr: 'Invalid QR',
  try_again: 'Try again',
});

const getRecipient = (is_multiple_recipient = false, credit_card_selected = true, phone_number_selected = true, bank_account_selected = true,
  iban_selected = false, customer_id_selected = false, cpf_cnpj_selected = false, email_selected = false, evp_selected = false) => ({
  screens_ordering: [
    'phone_number',
    'bank_account',
    'iban',
    'customer_id',
    'email',
    'cpf_cnpj',
    'evp',
    'credit_card',
  ],
  is_multiple_recipient,
  customer_should_select_recipient_request: true,
  select_from_recipients_list: true,
  add_recipient_manually: true,
  skip_contact_list_when_empty: false,
  contact_image: 'plus_sign',
  manual_recipients: {
    phone_number: getManualRecipients(manualNames[phone_number], manualDetails[phone_number], phone_number_selected),
    bank_account: getBankAccount(manualNames[bank_account], manualDetails[bank_account], bank_account_selected),
    iban: getManualRecipients(manualNames[iban], manualDetails[iban], iban_selected),
    customer_id: getManualRecipients(manualNames[customer_id], manualDetails[customer_id], customer_id_selected),
    email: getManualRecipients(manualNames[email], manualDetails[email], email_selected),
    cpf_cnpj: getManualRecipients(manualNames[cpf_cnpj], manualDetails[cpf_cnpj], cpf_cnpj_selected),
    evp: getManualRecipients(manualNames[evp], manualDetails[evp], evp_selected),
    credit_card: getManualRecipients(manualNames[credit_card], manualDetails[credit_card], credit_card_selected),
  },
  select_contact_title: 'Select recipient',
  select_recipient_details_type: 'Transfer money via',
  no_results: 'No results',
  translate_to: 'Transfer to 54012345678',
  search_contact_hint: 'Search contact',
  search_contact: 'Search',
  amount_participant_title: 'Amount per participant',
  participants: 'participants',
  total_payment: 'Total payment',
  recipient_information: 'Recipient information',
  cancel: 'Cancel',
  transfer_to_not_on_list: 'Transfer to someone not from the list',
  next: 'Next',
  save_to_contacts: 'Save to contacts',
});

const getBankAccount = (manual_name,
  enter_details,
  selected = false) => ({
  selected,
  manual_fields_list: {
    recipient_id: false,
    recipient_name: true,
    bank: true,
    branch_name: false,
    manual_name: true,
  },
  enable_recipient_validation: false,
  save_to_list: true,
  add_contact_name: true,
  search_from_list_bank: true,
  search_from_list_branch_name: true,
  manual_name,
  enter_details,
  recipient_id: 'Recipient ID',
  recipient_name: 'Recipient name',
  bank: 'Bank',
  branch_name: 'Branch',
  search_bank: 'Search bank',
  search_branch: 'Search branch',
  save_to_contacts: 'Save to contacts',
  add_contact_name_str: 'Contact Name',
  recipient_information: 'Recipient information',
  next: 'Next',
});

const getManualRecipients = (
  manual_name,
  enter_details,
  selected = false,
  manual_fields_list = {
    recipient_name: false,
    manual_name: true,
  },
) => ({
  selected,
  manual_fields_list,
  enable_recipient_validation: false,
  save_to_list: false,
  add_contact_name: true,
  manual_name,
  enter_details,
  recipient_name: 'Recipient name',
  save_to_contacts: 'Save to contacts',
  add_contact_name_str: 'Contact Name',
  recipient_information: 'Recipient information',
  next: 'Next',
});

const getAmount = () => ({
  show_account_balance: true,
  enable_additional_instruction: true,
  enable_select_currency: true,
  how_much_to_transfer: 'Enter total amount',
  enter_loan_amount: 'Enter loan amount',
  please_enter_valid_amount: 'Please enter a valid amount',
  account_balance: 'Account balance',
  select_paying_account: 'Select paying account',
  title: 'Select paying account',
  equivalent_to: 'Equivalent to',
});

const getNumber = () => ({
  enable_additional_instruction: true,
  enter_number_installments: 'Enter number of installments',
  next: 'Next',
});

const getSource = () => ({
  select_loan_source: 'Select loan source',
});

const getOption = () => ({
  select_loan_installment_options: true,
  multiple_columns: 'column_1',
  content_aligned_center: 'center',
  select_loan_option: 'Select installment option',
});

const getOperator = () => ({
  customer_should_select_a_mobile_operator: true,
  design_the_layout: 'column_1',
  select_mobile_operator_title: 'Select mobile operator',
});

const getAmountPackage = () => ({
  show_account_balance: true,
  enable_additional_instruction: true,
  package_configuration: 'packages',
  package_layout_columns: 'column_1',
  package_layout_aligned: 'left_aligned',
  select_mobile_package_title: 'Select a plan',
  account_balance: 'Account balance',
  select_paying_account: 'Select paying account',
  title: 'Select paying account',
  how_much_to_transfer: 'Enter total amount',
});

const getReference = () => ({
  step_enabled: true,
  customers_add_photo_enabled: false,
  select_reason_from_options: true,
  custom_reason: true,
  payment_reason: 'Payment reason',
  add_a_reference: 'Add a reference',
  next: 'Next',
  select_a_photo: 'Select a photo',
  enter_free_text: 'Add a note (optional)',
  select_payment_reason: 'Select payment reason',
  custom: 'Custom',
});

const getConfirmation = () => ({
  enable_transaction_fee_on_the_recipient: true,
  does_it_look_ok: 'Confirm payment details',
  transaction_fee_is_on_the_recipient: 'Service fee is on the recipient',
  more_details: 'More details',
  confirm: 'Send payment request',
  confirm_loan: 'Confirm loan',
  confirmation_sender_label: 'Your account',
  confirm_loan_details: 'Confirm loan details',
});

const getSuccess = () => ({
  enable_customer_to_share_transaction: true,
  sharing_method: 'receipt',
  enable_customer_to_make_another_transfer: true,
  your_receipt: 'Your receipt',
  share_in_chat: 'Share link',
  share_receipt: 'Share receipt',
  share: 'Share',
  go_back_to_menu: 'Go back to the menu',
  done: 'Done',
  make_another_transfer: 'Go back to the menu',
  copied_now_paste_to_chat: 'Copied, now paste in the chat',
  more_details: 'Show more details',
  close: 'Close',
});
